import { Component, Input, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { ModalController } from '@ionic/angular';
import { ConnectionService } from 'src/app/services/connection.service';
import { StorageService } from 'src/app/services/storage.service';

@Component({
  selector: 'app-health-claim-settlement',
  templateUrl: './health-claim-settlement.component.html',
  styleUrls: ['./health-claim-settlement.component.scss'],
})
export class HealthClaimSettlementComponent implements OnInit {
  @Input() dataSelected: any;
  highlightShow: boolean = true;
  features: boolean = false;
  claimprocess: boolean = false;
  cashless: boolean = false;
  portabilityShow: boolean = false;
  highlighSelected: boolean = true;
  featureSelected: boolean = false;
  claimprocessSelected = false;
  cashlessSelected = false;
  portabilitySelected = false;
  showMsg: boolean = false;
  show2Msg: boolean = false;
  show3Msg: boolean = false;
  show4Msg: boolean = false;
  cashlessOpen;
  cashlessHospital: any;
  items: any;
  filteredSearch: any;
  searchTerm: string;
  searchValue: string;
  careHospitalReq={
    city:'bangalore',
    hospitalname:null,
    pincode:null,
    district:null,
    state:null
  }

  careProducts: any = {
    care: false,
    enhance1:false
  }
  starProducts: any = {
    isStarProduct: false,
    familyHealthOptima: false,
    mediClassicIndividual: false,
    redCarpetIndividual: false,
    redCarpetFloater: false,
    comprehensiveIndividual: false,
    comprehensiveFloater: false,
    youngStarIndividual: false,
    youngStarFloater: false,
  }
  emiLabel: any = "";
  topUpIns: any;

  constructor(private modalCtrl: ModalController,private route: ActivatedRoute,private strg: StorageService,private apiService: ConnectionService) { }

  ngOnInit() {
    this.route.queryParamMap.subscribe((params: any) => this.topUpIns = params.params.data);
    if(this.dataSelected.installmentType){
      if(this.dataSelected.installmentType === 1){
        this.emiLabel = "/ Monthly";
      } else if(this.dataSelected.installmentType === 2){
        this.emiLabel = "/ Quarterly";
      } else if(this.dataSelected.installmentType === 3){
        this.emiLabel = " / Half-Yearly";
      } else{
        this.emiLabel = "";
      }
    }
    if(this.dataSelected.productName === "Care"){
      this.careProducts.care = true;
    } 
    else if(this.dataSelected.productName === "Enhance 1" || this.dataSelected.productName === "Enhance 2")
    {
      this.careProducts.enhance1 = true;
    }
    else if(this.dataSelected.productName === "Family Health Optima"){
      this.careProducts.care = false;
      Object.keys(this.starProducts).forEach((key) => {
        if(key === "familyHealthOptima" || key === "isStarProduct")
          this.starProducts[key] = true;
        else
          this.starProducts[key] = false;
      });
    } else if(this.dataSelected.productName === "Medi-Classic Individual"){
      this.careProducts.care = false;
      Object.keys(this.starProducts).forEach((key) => {
        if(key === "mediClassicIndividual" || key === "isStarProduct")
          this.starProducts[key] = true;
        else
          this.starProducts[key] = false;
      });
    } 
    else if(this.dataSelected.productName === "Red Carpet Floater"){
      this.careProducts.care = false;
      Object.keys(this.starProducts).forEach((key) => {
        if(key === "redCarpetFloater" || key === "isStarProduct")
          this.starProducts[key] = true;
        else
          this.starProducts[key] = false;
      });
    }
    else if(this.dataSelected.productName === "Red Carpet Individual"){
      this.careProducts.care = false;
      Object.keys(this.starProducts).forEach((key) => {
        if(key === "redCarpetIndividual" || key === "isStarProduct")
          this.starProducts[key] = true;
        else
          this.starProducts[key] = false;
      });
    }
    else if(this.dataSelected.productName === "Comprehensive Floater"){
      this.careProducts.care = false;
      Object.keys(this.starProducts).forEach((key) => {
        if(key === "comprehensiveFloater" || key === "isStarProduct")
          this.starProducts[key] = true;
        else
          this.starProducts[key] = false;
      });
    }
    else if(this.dataSelected.productName === "Comprehensive Individual"){
      this.careProducts.care = false;
      Object.keys(this.starProducts).forEach((key) => {
        if(key === "comprehensiveIndividual" || key === "isStarProduct")
          this.starProducts[key] = true;
        else
          this.starProducts[key] = false;
      });
    }
    else if(this.dataSelected.productName === "Young Star Floater"){
      this.careProducts.care = false;
      Object.keys(this.starProducts).forEach((key) => {
        if(key === "youngStarFloater" || key === "isStarProduct")
          this.starProducts[key] = true;
        else
          this.starProducts[key] = false;
      });
    }
    else if(this.dataSelected.productName === "Young Star Individual"){
      this.careProducts.care = false;
      Object.keys(this.starProducts).forEach((key) => {
        if(key === "youngStarIndividual" || key === "isStarProduct")
          this.starProducts[key] = true;
        else
          this.starProducts[key] = false;
      });
    }

    if (this.cashlessOpen === true) {
      this.highlightShow = false;
      this.features = false;
      this.claimprocess = false;
      this.cashless = true;
      this.portabilityShow = false;
      this.cashless = true;
      this.portabilityShow = false;
      this.highlighSelected = false;
      this.featureSelected = false;
      this.claimprocessSelected = false;
      this.cashlessSelected = true;
      this.portabilitySelected = false;
    }
    this.searchValue='';
    this.searchTerm="city";      
  }

  setFilteredLocations(e){
    this.careHospitalReq.city=null;
    this.careHospitalReq.district=null;
    this.careHospitalReq.hospitalname=null;
    this.careHospitalReq.pincode=null;
    this.careHospitalReq.state=null;
    let targetValue=e.target.value;
    if(this.searchTerm==='city'){
      this.careHospitalReq.city=targetValue; 
  }
  else if(this.searchTerm==='hospital'){
    this.careHospitalReq.hospitalname=targetValue;
  }
  else if(this.searchTerm==='pincode'){
    this.careHospitalReq.pincode=targetValue;

  }
  this.apiService.postCashLessHospital(this.careHospitalReq).subscribe(res=>{
    this.cashlessHospital=res.data.content
   })
  }

  showHighlight() {
    this.highlightShow = true;
    this.features = false;
    this.claimprocess = false;
    this.cashless = false;
    this.portabilityShow = false;
    this.highlighSelected = true;
    this.featureSelected = false;
    this.claimprocessSelected = false;
    this.cashlessSelected = false;
    this.portabilitySelected = false;
  }
  showFeatures() {
    this.highlightShow = false;
    this.features = true;
    this.claimprocess = false;
    this.cashless = false;
    this.portabilityShow = false;
    this.highlighSelected = false;
    this.featureSelected = true;
    this.claimprocessSelected = false;
    this.cashlessSelected = false;
    this.portabilitySelected = false;
  }
  showClaim() {
    this.highlightShow = false;
    this.features = false;
    this.claimprocess = true;
    this.cashless = false;
    this.portabilityShow = false;
    this.highlighSelected = false;
    this.featureSelected = false;
    this.claimprocessSelected = true;
    this.cashlessSelected = false;
    this.portabilitySelected = false;

  }
  cashlessHosp() {
    this.highlightShow = false;
    this.features = false;
    this.claimprocess = false;
    this.cashless = true;
    this.portabilityShow = false;
    this.highlighSelected = false;
    this.featureSelected = false;
    this.claimprocessSelected = false;
    this.cashlessSelected = true;
    this.portabilitySelected = false;
  }
  portability() {
    this.highlightShow = false;
    this.features = false;
    this.claimprocess = false;
    this.cashless = false;
    this.portabilityShow = true;
    this.highlighSelected = false;
    this.featureSelected = false;
    this.claimprocessSelected = false;
    this.cashlessSelected = false;
    this.portabilitySelected = true;
  }
  closeModal() {
    this.modalCtrl.dismiss({});
  }
  clickOpen() {
    this.show3Msg = false;
    this.showMsg = !this.showMsg;
    this.show2Msg = false;
    this.show4Msg = false;
  }
  click2Open() {
    this.show3Msg = false
    this.show2Msg = !this.show2Msg;
    this.showMsg = false;
    this.show4Msg = false;
  }
  click3Open() {
    this.show3Msg = !this.show3Msg;
    this.show2Msg = false;
    this.showMsg = false;
    this.show4Msg = false;
  }
  click4Open() {
    this.show4Msg = !this.show4Msg;
    this.show3Msg = false;
    this.show2Msg = false
    this.showMsg = false
  }
}
